import { useTranslation } from 'react-i18next'
import {
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"

const useRenderTableContent = (missionSubjectConfig, resize) => {
  const [t] = useTranslation('common')

  const renderTableHeader = () => {
    if (missionSubjectConfig.withEggs) {
      return <>
        <HeaderCell resize={resize}>{t('table.found_nests')}</HeaderCell>
        <HeaderCell resize={resize}>{t('table.empty_nests')}</HeaderCell>
        <HeaderCell resize={resize}>{t('table.nb_non_treated_nests')}</HeaderCell>
        <HeaderCell resize={resize}>{t('table.nb_eggs')}</HeaderCell>
        <HeaderCell resize={resize}>{t('table.nb_non_treated_eggs')}</HeaderCell>
        <HeaderCell resize={resize}>{t('table.nb_birds')}</HeaderCell>
      </>
    }

    if (!missionSubjectConfig.withEggs) {
      return <>
        <HeaderCell resize={resize}>{t('table.found')}</HeaderCell>
        <HeaderCell resize={resize}>{t('table.nb_treated')}</HeaderCell>
        <HeaderCell resize={resize}>{t('table.nb_non_treated')}</HeaderCell>
      </>
    }
  }

  const renderTableCells = item => {
    if (missionSubjectConfig.withEggs) {
      return <>
        <Cell>{item.totalNests}</Cell>
        <Cell>{item.totalEmptyNests}</Cell>
        <Cell>{item.totalNonTreatedNests}</Cell>
        <Cell>{item.totalEggs}</Cell>
        <Cell>{item.totalNonTreatedEggs}</Cell>
        <Cell>{item.totalBirds}</Cell>
      </>
    }

    if (!missionSubjectConfig.withEggs) {
      return <>
        <Cell>{item.total}</Cell>
        <Cell>{item.totalTreated}</Cell>
        <Cell>{item.totalNonTreated}</Cell>
      </>
    }
  }

  return [renderTableHeader, renderTableCells]
}

export default useRenderTableContent